import { VideoConsentPlugin } from "./consentVideo";
import StartRecordPlugin from "./start";
import StopRecordPlugin from "./stop";
import TrialRecordExtension from "./trial";
import VideoConfigPlugin from "./videoConfig";

export default {
  TrialRecordExtension,
  StartRecordPlugin,
  StopRecordPlugin,
  VideoConfigPlugin,
  VideoConsentPlugin,
};
